export const CREATE_SONG_MODAL = 'create_song_modal';
